import InvoiceForm from "../../components/InvoiceComponents/InvoiceForm";

function NewInvoicePage() {
  return <InvoiceForm method="post" title="Invoice" />;
}

export default NewInvoicePage;
